// ONE source of truth for the periods of a crew member (table crew_leave): Crew > profile > Leave AND Rotation both build
// their lists and totals from rotationPeriods(), so they can never show different dates or days.
// Rules:
//  - a period with an end date ends there (nothing is stretched to today);
//  - no end date = ongoing, but only while it matches the person: a Leave / Training / ... period while ashore, a Working
//    period while signed on. It then counts days up to today. A period without an end date that does NOT match (open leave
//    while signed on, open Working while ashore) shows "no end date" and is not counted;
//  - signed on and nothing recorded since the last period ended: the days since then show as one Working period, ongoing;
//  - 'Working ashore' counts as worked days; 'Unpaid leave' is not leave taken;
//  - days always come from the dates (the stored Days column is ignored); 'Paid Off' rows are day counts, not periods;
//  - consecutive same-type periods with adjacent dates are ONE period (a rotation over New Year).
export const nextDay = d => { const m = new Date(d + 'T12:00:00'); m.setDate(m.getDate() + 1); return m.toISOString().split('T')[0] }
export const prevDay = d => { const m = new Date(d + 'T12:00:00'); m.setDate(m.getDate() - 1); return m.toISOString().split('T')[0] }
export function leaveDays(a, b) {
  if (!a || !b) return 0
  const d1 = new Date(a + 'T12:00:00'), d2 = new Date(b + 'T12:00:00')
  if (isNaN(d1) || isNaN(d2)) return 0
  return Math.max(0, Math.round((d2 - d1) / 86400000) + 1)
}
// blocks: crew_leave rows ('Start Date', 'End Date', 'Leave Type', 'Notes', id); onboard: signed on now; todayISO: 'YYYY-MM-DD'
// types: Working (on board), 'Working ashore' (travel, training, yard, office: counts as worked, not on board), Leave (counts as leave taken),
// 'Unpaid leave' and the rest (shown, but neither worked nor leave taken)
// -> { periods (oldest first: { type, start, end, ongoing, noEnd, days, ids, notes }), worked, leave ('Leave' type), other (the rest) }
export function rotationPeriods(blocks, { onboard = false, todayISO } = {}) {
  const raw = [...(blocks || [])].filter(l => l['Start Date'] && (l['Leave Type'] || 'Leave') !== 'Paid Off')
    .sort((a, b) => String(a['Start Date']).localeCompare(String(b['Start Date'])))
  const merged = []
  raw.forEach(b => {
    const type = b['Leave Type'] || 'Leave', start = b['Start Date'], end = b['End Date'] || ''
    const note = b['Notes'] || '', id = b.id
    const last = merged[merged.length - 1]
    if (last && end && last.end && last.type === type && (last.end === start || nextDay(last.end) === start || nextDay(last.end) === nextDay(start))) {
      last.end = end; last.ids.push(id); if (note && !last.notes.includes(note)) last.notes.push(note)
    } else merged.push({ type, start, end, ids: [id], notes: note ? [note] : [] })
  })
  merged.forEach(m => {
    m.ongoing = false; m.noEnd = false
    m.notes = m.notes.join(' · ')
    if (!m.end) {
      if ((m.type === 'Working') === !!onboard) { m.end = todayISO; m.ongoing = true } else m.noEnd = true
    }
  })
  const lastEnd = merged.reduce((mx, m) => (m.end && m.end > mx ? m.end : mx), '')
  if (onboard && merged.length && lastEnd && lastEnd < todayISO && !merged.some(m => m.ongoing || m.noEnd)) {
    merged.push({ type: 'Working', start: nextDay(lastEnd), end: todayISO, ongoing: true, noEnd: false, ids: [], notes: '' })
  }
  merged.forEach(m => { m.days = m.noEnd ? 0 : leaveDays(m.start, m.end) })
  const sum = f => merged.filter(f).reduce((s, m) => s + m.days, 0)
  return { periods: merged, worked: sum(m => m.type === 'Working' || m.type === 'Working ashore'), leave: sum(m => m.type === 'Leave'), other: sum(m => m.type !== 'Working' && m.type !== 'Working ashore' && m.type !== 'Leave') }
}
